import { render } from "./Edit.vue?vue&type=template&id=47e0449c&scoped=true"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=47e0449c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47e0449c"],['__file',"src/views/EmailTemplates/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "47e0449c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('47e0449c', __exports__)) {
    api.reload('47e0449c', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=47e0449c&scoped=true", () => {
    api.rerender('47e0449c', render)
  })

}


export default __exports__